import PropTypes from 'prop-types'
import './timeline.scss'

const Timeline = ({ years, selectedYear, onYearChange }) => {
  return (
    <div className='timeline-container'>
      <div className='timeline-wrapper'>
        <div className='timeline-line' aria-hidden='true'></div>
        <div className='timeline-years'>
          {years.map((year) => (
            <button
              key={year}
              className={`timeline-year ${selectedYear === year ? 'active' : ''}`}
              onClick={() => onYearChange(year)}
              aria-pressed={selectedYear === year}
              aria-label={`Ver memorias del año ${year}`}
            >
              <span className='timeline-year-label'>{year}</span>
              <span className='timeline-year-dot' aria-hidden='true'></span>
            </button>
          ))}
        </div>
        <div className='timeline-scroll-hint' aria-hidden='true'>
          <span>Desliza para ver más años</span>
          <span className='timeline-scroll-hint__arrow'>→</span>
        </div>
      </div>
    </div>
  )
}

Timeline.propTypes = {
  years: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedYear: PropTypes.number.isRequired,
  onYearChange: PropTypes.func.isRequired
}

export default Timeline
